import '../../../base/css/base.pcss';
import '../../../base/js/base';

import '../../parts/header/index';
import '../../parts/footer/index';

/* shortcodes */
import '../../shortcodes/bordered-text-block/index';
import '../../shortcodes/text-with-solid-bg/index';
import '../../shortcodes/contact-block/index';

/* modules */
import '../../modules/icon-tabs/index';
import '../../modules/side-testimonial-block/index';

/* page templates */
import '../../templates/page/index';
import '../../templates/with-case-studies-footer/index';

import './customised-coaching-and-training-programs.pcss';
import './customised-coaching-and-training-programs';